export default __webpack_public_path__ + "img/bd2ed1a06fb80e6a220ff7a03d78a9f8.svg";